import React, { Component, Fragment } from 'react';

import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { Grid, Box } from '@mui/material';

import styles from './styles';
import moment from 'moment';
import ShipmentList from './ShipmentList';
import AssignmentDetail from './AssignmentDetail';

class AssignmentDetailContainer extends Component {
  constructor(props) {
    super(props);
  }

  onSelectStop = (s) => {
    const { store, history } = this.props;
    const { shipmentStore, assignmentStore } = store;
    const { regions, selectedAssignmentId, date } = assignmentStore;
    const region = regions.length > 0 ? regions.join(',') : 'all';
    if (s.id === shipmentStore.selectedStopId) {
      history.push(`/routes/${date}/${region}/${selectedAssignmentId || ''}`);
      shipmentStore.selectStop(null);
    } else {
      history.push(`/routes/${date}/${region}/${selectedAssignmentId || '-'}/stops/${s.id}`);
      shipmentStore.selectStop(s);
    }
  };

  render() {
    return (
      <Box sx={styles.container}>
        <Grid container direction="column" sx={styles.gridContainer}>
          <Grid size="grow" sx={styles.shipmentsList}>
            <ShipmentList onSelectStop={(s) => this.onSelectStop(s)} />
          </Grid>
          <Grid sx={styles.assignmentDetail}>
            <AssignmentDetail onShowMessenger={this.props.onShowMessenger} />
          </Grid>
        </Grid>
      </Box>
    );
  }
}

const AssignmentDetailContainerCompose = compose(inject('store'), observer)(AssignmentDetailContainer);

export default withRouter(AssignmentDetailContainerCompose);
